module.exports = __webpack_public_path__ + "img/sinisa_kovacic.4bb26179.png";